import { render, staticRenderFns } from "./PagingComponent.vue?vue&type=template&id=0e6ed148&scoped=true"
import script from "./PagingComponent.vue?vue&type=script&lang=js"
export * from "./PagingComponent.vue?vue&type=script&lang=js"
import style0 from "./PagingComponent.vue?vue&type=style&index=0&id=0e6ed148&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6ed148",
  null
  
)

export default component.exports